import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cc1f8ff0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "page-card" }
const _hoisted_2 = { class: "dc-card-header" }
const _hoisted_3 = { class: "dc-card-header-defaut" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dc-card-header-defaut-line" }, null, -1))
const _hoisted_5 = { class: "dc-card-header-defaut-subtitle" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "paddingLine" }, null, -1))
const _hoisted_7 = { class: "dc-card-header" }
const _hoisted_8 = { class: "dc-card-header-defaut" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dc-card-header-defaut-line" }, null, -1))
const _hoisted_10 = { class: "dc-card-header-defaut-subtitle" }

import { ref, reactive, computed, onMounted, watch, PropType, onActivated, nextTick } from 'vue'
import { useRoute } from 'vue-router'
import Editor from '@/components/Editor'
import CosSingleDateTimePicker from '@/components/CosSingleDateTimePicker/index.vue'
import UploadFile from '@/components/UploadFile'
import ClueAndCustomerSelect from '@/components/ClueAndCustomerSelect/index.vue'
import BusinessForm from '@/views/overseasSales/chanceManage/business/components/BusinessForm.vue'
import AlarmList from './alarmList.vue'
import VisitorProgramForm from '../../components/VisitorProgramForm.vue'
import { goBack } from '@/hooks/cosRouter'
import { listByParamCodes } from '@/api/common'
import type { Rule } from 'ant-design-vue/es/form'
import {
  followRecordsAddByMess,
  followRecordsAddOrUpdate,
  followRecordsDetail,
  followRecordsDate
  // visitorProgramDetail
} from '@/api/overseasSales/followUpManage'
import type { FbuFollowUpRecordEdit } from '@/typings/api/followUpManage'
import { DcMessage, DcConfirm } from '@dc-platform/dc-components'
import BusinessName from '@/components/BusinessName/index.vue'
import { cloneDeep } from 'lodash-es'
import dayjs, { Dayjs } from 'dayjs'
import { selectForNumberValidate } from '@/utils/validate'
import { MessageOutlined } from '@ant-design/icons-vue'
import { paramCodesDataFilter } from '@/utils/index'
import { useI18n } from 'vue-i18n'

const __default__ = { name: 'BaseMessage' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  disabled: {
    type: Boolean,
    default: true
  },
  data: {
    type: Object as PropType<FbuFollowUpRecordEdit>
  },
  permissionPage: {
    type: Object,
    default: () => {
      return {}
    }
  },
  view: {
    type: Boolean
  },
  hideOk: {
    type: Boolean
  }
},
  emits: ['getDetail'],
  setup(__props, { emit: __emit }) {

const { t } = useI18n()
const route = useRoute()
const props = __props
// const signInListOptions = ref()
const baseFormRef = ref()
const saleChanceFormRef = ref()
const visitorProgramFormRef = ref()
const alarmListFromRef = ref()

const form = ref<any>({
  saleChance: {},
  visitPlanList: {}
})
const resetValue = ref<FbuFollowUpRecordEdit>({
  saleChance: {},
  visitPlanList: {}
})
const hasSaleChance = ref(false)
const hasplay = ref(false)
const loading = ref(false)
const startDate = ref(dayjs(new Date()).subtract(3, 'day').endOf('day'))
const paramCodeData = ref<{
  ofbu_follow_mode: []
  ofbu_follow_purpose: []
}>({
  ofbu_follow_mode: [], // 拜访方式
  ofbu_follow_purpose: [] // 访客目的
})
const followUpOptions = reactive<{
  contactList: any[]
  saleChanceList: any[]
  visitPlanList: any[]
}>({
  contactList: [],
  saleChanceList: [],
  visitPlanList: []
})
const disabledDate = (current: Dayjs) => {
  return current > dayjs(new Date()) || current < startDate.value
}
// 商机必填校验
const chanceIdRequired = computed(() => {
  if (form.value.fbuPurposeTxt === '处理异常' || form.value.fbuPurposeTxt === '客情维护') {
    return false
  }
  if (form.value.fbuPurposeTxt === '深耕商机') {
    return true
  }
  if (!saleChanceData.value || !saleChanceData.value.length) {
    return false
  }
  return true
})
// 有一二级异动信息存在时，目的只能选择【处理异动】
const purposeByAlarmValidate = async (rule: Rule, value: string) => {
  const { alarmHasMain, fbuPurposeTxt } = form.value
  if (alarmHasMain && fbuPurposeTxt && fbuPurposeTxt !== '处理异动') {
    return Promise.reject(new Error(t('exception.followChangeFeedbackTips1')))
  } else {
    return Promise.resolve()
  }
}
// 处理访客计划数据(只处理详情)
const visitPlanData = computed(() => {
  const { planId, planTitle } = form.value
  const { visitPlanList } = followUpOptions
  if (planId && planTitle && route.query.id) {
    const obj = visitPlanList.find((item: any) => item.id === planId)
    if (!obj) {
      visitPlanList.unshift({
        id: planId,
        title: planTitle,
        disabled: true
      })
    }
  }
  return visitPlanList
})
// 处理商机数据(只处理详情)
const saleChanceData = computed(() => {
  const { chanceId, chanceName, fbuPurposeTxt } = form.value
  const { saleChanceList } = followUpOptions
  // 深耕商机 可以选择5未能合作与4达成合作商机
  let newSaleChanceList = cloneDeep(saleChanceList)
  if (fbuPurposeTxt !== '深耕商机') {
    newSaleChanceList = saleChanceList.filter((v: any) => v.status !== 4 && v.status !== 5)
  }
  if (chanceId && chanceName && (route.query.id || route.query.planId)) {
    const obj = newSaleChanceList.find((item: any) => item.chanceId === chanceId)
    if (!obj) {
      newSaleChanceList.unshift({
        chanceId: chanceId,
        saleChanceName: chanceName,
        disabled: true
      })
    }
  }
  return newSaleChanceList
})
// 目的修改
const changePurpose = (v: string) => {
  nextTick(() => {
    const { fbuPurposeTxt, chanceId } = form.value
    if (fbuPurposeTxt !== '深耕商机' && chanceId) {
      const obj = saleChanceData.value.find((item) => item.chanceId === chanceId)
      if (!obj || (obj && obj.disabled)) {
        form.value.chanceId = undefined
      }
    }
  })
}
watch(
  () => props.data,
  (v, prev) => {
    if (v) {
      form.value = v
      resetValue.value = cloneDeep(v)
    }
  },
  { immediate: true }
)
const emit = __emit
// 获取详情
const fetch = () => {
  if (route.query.id) {
    loading.value = true
    followRecordsDetail(route.query.id)
      .then((res) => {
        form.value = res.data
        emit('getDetail', res.data)
        resetValue.value = cloneDeep(res.data)
      })
      .finally(() => {
        loading.value = false
      })
  }
}
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_ofbu',
    paramCodes: ['ofbu_follow_mode', 'ofbu_follow_purpose']
  }).then((res) => {
    if (res.code === 200) {
      if (props.view) {
        paramCodeData.value = {
          ...res.data
        }
      } else {
        // 递归过滤业务参数状态
        res.data = paramCodesDataFilter(res.data, 0)
        paramCodeData.value = {
          ...res.data
        }
      }
    }
  })
}
// 获取跟进记录日期
const getDate = () => {
  followRecordsDate().then((res) => {
    if (res.data) {
      startDate.value = dayjs(res.data)
    }
  })
}
// 获取客户相关信息（访客计划，联系人，商机）
const getMessage = () => {
  if (form.value.followRefId) {
    followRecordsAddByMess({
      followRefId: form.value.followRefId
    }).then((res) => {
      const { contactList, saleChanceList, visitPlanList } = res.data
      followUpOptions.contactList = contactList && contactList.length ? contactList : []
      followUpOptions.saleChanceList = saleChanceList && saleChanceList.length ? saleChanceList : []
      followUpOptions.visitPlanList = visitPlanList && visitPlanList.length ? visitPlanList : []
      // 设置联系人默认值
      if (contactList && contactList.length === 1) {
        if (!form.value.contactId) {
          form.value = {
            ...form.value,
            contactId: contactList[0].id,
            contactName: contactList[0].name
          }
          resetValue.value = cloneDeep(form.value)
        }
      }
    })
  }
}
// 客户修改
const changeCus = (v: any) => {
  form.value = {
    ...form.value,
    followRefId: v,
    contactId: undefined,
    contactName: undefined,
    planId: undefined,
    chanceId: undefined,
    saleChance: {
      ...form.value.saleChance,
      saleChanceRefId: v
    },
    visitPlanList: {
      ...form.value.visitPlanList,
      visitRefId: v,
      chanceId: undefined
    }
  }
}
// 回显数据监听客户名称变化
watch(
  () => form.value.followRefId,
  (val) => {
    if (val) {
      getMessage()
    }
  },
  { immediate: true }
)
watch(
  () => form.value.alarmHasMain,
  (val) => {
    if (val) {
      // 设置默认值
      const purpose: any = paramCodeData.value.ofbu_follow_purpose?.find((item: any) => item.cnName === '处理异动')
      if (purpose && (!form.value.fbuPurpose || form.value.fbuPurpose === -9)) {
        form.value.fbuPurpose = purpose.id
        form.value.fbuPurposeTxt = '处理异动'
      }
    }
  },
  { immediate: true }
)
const changeContactId = (v: any, option: any) => {
  form.value.contactName = option ? option.name : undefined
}
// 提交表单
const submitSure = async () => {
  // 处理联系人
  const p = {
    ...form.value,
    saleChance: hasSaleChance.value ? form.value.saleChance : undefined,
    visitPlanList: hasplay.value ? [form.value.visitPlanList] : undefined
  }
  loading.value = true
  try {
    await followRecordsAddOrUpdate(p)
    if (route.query.planId) {
      DcMessage.success(t('tips.completeCallSuccess'))
    } else if (route.query.id) {
      DcMessage.success(t('tips.editSuccess'))
    } else {
      DcMessage.success(t('tips.addSuccess'))
    }
    goBack()
  } catch (error) {}
  loading.value = false
}
// 提交表单
const handleSubmit = async () => {
  const alarmListFromRefVali = alarmListFromRef.value?.validate()
  const baseFormRefVali = baseFormRef.value?.validate()
  const saleChanceFormRefVali = saleChanceFormRef.value?.validate()
  const visitorProgramFormRefVali = visitorProgramFormRef.value?.validate()
  Promise.all([baseFormRefVali, saleChanceFormRefVali, visitorProgramFormRefVali, alarmListFromRefVali]).then(
    async (res) => {
      submitSure()
    }
  )
}
// 重置访客计划、商机表单
const handleReset = () => {
  hasSaleChance.value = false
  hasplay.value = false
  form.value.saleChance = {}
  form.value.visitPlanList = {}
  alarmListFromRef.value?.reset()
}
// 校验访客计划、商机表单
const validate = () => {
  saleChanceFormRef.value?.validate()
  alarmListFromRef.value?.validate()
  visitorProgramFormRef.value?.validate()
}
// 点击新增访客计划
const addVisitPlan = () => {
  hasplay.value = true
  form.value.visitPlanList = {
    visitRefId: form.value.followRefId
  }
}
// 点击新增销售商机
const addSaleChance = () => {
  hasSaleChance.value = true
  form.value.saleChance = {
    saleChanceRefId: form.value.followRefId
  }
}
const init = () => {
  if (route.query.followRefId) {
    form.value = {
      chanceId: route.query.chanceId as string,
      followRefId: route.query.followRefId as string,
      saleChance: {
        saleChanceRefId: route.query.followRefId
      },
      visitPlanList: {
        visitRefId: route.query.followRefId
      }
    }
    resetValue.value = cloneDeep(form.value)
  }
  fetch()
  getByParamCodes()
}
onMounted(() => {
  init()
  getDate()
})
// 缓存
onActivated(() => {
  getMessage()
  getDate()
})

return (_ctx: any,_cache: any) => {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_CosSelect = _resolveComponent("CosSelect")!
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_user_select = _resolveComponent("user-select")!
  const _component_CosInput = _resolveComponent("CosInput")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_dc_layout_card = _resolveComponent("dc-layout-card")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cos_footer_button = _resolveComponent("cos-footer-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_form, {
      name: "detailsForm",
      ref_key: "baseFormRef",
      ref: baseFormRef,
      model: form.value
    }, {
      default: _withCtx(() => [
        _createVNode(_component_dc_layout_card, {
          title: _unref(t)('follow.followRecord')
        }, {
          default: _withCtx(() => [
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('follow.customerName'),
              name: "followRefId",
              rules: [{ required: true, message: _unref(t)('common.pleaseSelect') }]
            }, {
              label: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('follow.customerName')) + " ", 1),
                (form.value.preFollowRefName)
                  ? (_openBlock(), _createBlock(_component_a_tooltip, {
                      key: 0,
                      placement: "top"
                    }, {
                      title: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(t)('follow.mergeByCoustorm', { preFollowRefName: form.value.preFollowRefName })), 1)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_unref(MessageOutlined), { style: {"margin-left":"4px"} })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                _createVNode(ClueAndCustomerSelect, {
                  appId: "cos_ofbu",
                  value: form.value.followRefId,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((form.value.followRefId) = $event)),
                  label: form.value.customerName,
                  "onUpdate:label": _cache[1] || (_cache[1] = ($event: any) => ((form.value.customerName) = $event)),
                  disabled: __props.disabled || (_unref(route).query.followRefId || _unref(route).query.planId ? true : false),
                  onChange: changeCus,
                  view: __props.view
                }, null, 8, ["value", "label", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('follow.planTitle'),
              name: "planId"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosSelect, {
                  value: form.value.planId,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((form.value.planId) = $event)),
                  fieldNames: {
            label: 'title',
            value: 'id'
          },
                  options: visitPlanData.value,
                  disabled: __props.disabled || _unref(route).query.planId ? true : false,
                  view: __props.view
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('follow.fllowTime'),
              name: "startTime",
              rules: [{ required: true, message: _unref(t)('common.pleaseSelect') }]
            }, {
              default: _withCtx(() => [
                _createVNode(CosSingleDateTimePicker, {
                  isOutputBeijingTime: "",
                  startTime: form.value.startTime,
                  "onUpdate:startTime": _cache[3] || (_cache[3] = ($event: any) => ((form.value.startTime) = $event)),
                  endTime: form.value.endTime,
                  "onUpdate:endTime": _cache[4] || (_cache[4] = ($event: any) => ((form.value.endTime) = $event)),
                  isRange: true,
                  disabled: __props.disabled,
                  view: __props.view,
                  "disabled-date": disabledDate
                }, null, 8, ["startTime", "endTime", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              name: "contactId",
              label: _unref(t)('follow.followContacts'),
              rules: [
          { required: true, validator: _unref(selectForNumberValidate), message: _unref(t)('common.pleaseSelect'), trigger: 'change' }
        ]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_CosSelect, {
                  value: form.value.contactId,
                  "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((form.value.contactId) = $event)),
                  fieldNames: {
            label: 'name',
            value: 'id'
          },
                  allowClear: "",
                  onChange: changeContactId,
                  options: followUpOptions.contactList,
                  disabled: __props.disabled,
                  view: __props.view
                }, null, 8, ["value", "options", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('follow.purpose'),
              name: "fbuPurpose",
              rules: [
          { required: true, validator: _unref(selectForNumberValidate), message: _unref(t)('common.pleaseSelect') },
          {
            validator: purposeByAlarmValidate,
            trigger: 'blur'
          }
        ]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  options: paramCodeData.value.ofbu_follow_purpose,
                  value: form.value.fbuPurpose,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((form.value.fbuPurpose) = $event)),
                  label: form.value.fbuPurposeTxt,
                  "onUpdate:label": _cache[7] || (_cache[7] = ($event: any) => ((form.value.fbuPurposeTxt) = $event)),
                  disabled: __props.disabled,
                  onChange: changePurpose,
                  view: __props.view
                }, null, 8, ["options", "value", "label", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('follow.followMethod'),
              name: "mode",
              rules: [{ required: true, validator: _unref(selectForNumberValidate), message: _unref(t)('common.pleaseSelect') }]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ParamCodesSelect, {
                  options: paramCodeData.value.ofbu_follow_mode,
                  label: form.value.fbuFollowTxt,
                  "onUpdate:label": _cache[8] || (_cache[8] = ($event: any) => ((form.value.fbuFollowTxt) = $event)),
                  value: form.value.mode,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((form.value.mode) = $event)),
                  disabled: __props.disabled,
                  view: __props.view
                }, null, 8, ["options", "label", "value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('follow.associatedOpportunities'),
              name: "chanceId",
              rules: [
          {
            required: chanceIdRequired.value,
            message: _unref(t)('common.pleaseSelect')
          }
        ]
            }, {
              default: _withCtx(() => [
                (__props.view)
                  ? (_openBlock(), _createBlock(BusinessName, {
                      key: 0,
                      appId: "cos_ofbu",
                      value: form.value.chanceName,
                      "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((form.value.chanceName) = $event))
                    }, null, 8, ["value"]))
                  : (_openBlock(), _createBlock(_component_CosSelect, {
                      key: 1,
                      filterNoVal: "",
                      value: form.value.chanceId,
                      "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((form.value.chanceId) = $event)),
                      allowClear: "",
                      disabled: __props.disabled,
                      view: __props.view
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(saleChanceData.value, (item) => {
                          return (_openBlock(), _createBlock(_component_a_select_option, {
                            key: item.chanceId,
                            disabled: item.disabled
                          }, {
                            default: _withCtx(() => [
                              _createVNode(BusinessName, {
                                appId: "cos_ofbu",
                                value: item.saleChanceName,
                                "onUpdate:value": ($event: any) => ((item.saleChanceName) = $event)
                              }, null, 8, ["value", "onUpdate:value"])
                            ]),
                            _: 2
                          }, 1032, ["disabled"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["value", "disabled", "view"]))
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            _createVNode(_component_dc_form_item, {
              name: "fbuAssistPersons",
              label: _unref(t)('follow.collaborator')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_user_select, {
                  value: form.value.fbuAssistPersons,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((form.value.fbuAssistPersons) = $event)),
                  disabled: __props.disabled,
                  mode: "multiple",
                  view: __props.view
                }, null, 8, ["value", "disabled", "view"])
              ]),
              _: 1
            }, 8, ["label"]),
            (__props.disabled)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('follow.dutyByName')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.dutyByName,
                        "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((form.value.dutyByName) = $event)),
                        view: __props.view,
                        disabled: __props.disabled
                      }, null, 8, ["value", "view", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('common.createByName')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.createByName,
                        "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((form.value.createByName) = $event)),
                        view: __props.view,
                        disabled: __props.disabled
                      }, null, 8, ["value", "view", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_dc_form_item, {
                    label: _unref(t)('common.createTime')
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosInput, {
                        value: form.value.createTime,
                        "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((form.value.createTime) = $event)),
                        view: __props.view,
                        disabled: __props.disabled
                      }, null, 8, ["value", "view", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ], 64))
              : _createCommentVNode("", true),
            _createVNode(_component_a_col, { span: 24 }, {
              default: _withCtx(() => [
                _createVNode(AlarmList, {
                  cosId: form.value.followRefId,
                  followId: form.value.id,
                  alarmHasMain: form.value.alarmHasMain,
                  "onUpdate:alarmHasMain": _cache[16] || (_cache[16] = ($event: any) => ((form.value.alarmHasMain) = $event)),
                  value: form.value.alarmProcess,
                  "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((form.value.alarmProcess) = $event)),
                  ref_key: "alarmListFromRef",
                  ref: alarmListFromRef,
                  view: __props.view
                }, null, 8, ["cosId", "followId", "alarmHasMain", "value", "view"])
              ]),
              _: 1
            }),
            _createVNode(_component_dc_form_item, {
              label: _unref(t)('follow.processDetail'),
              name: "process",
              span: 24,
              rules: [{ required: true, message: _unref(t)('common.pleaseInput') }]
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(Editor), {
                  maxlength: 30000,
                  disabled: __props.disabled,
                  value: form.value.process,
                  "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((form.value.process) = $event)),
                  mention: form.value.userCodes,
                  "onUpdate:mention": _cache[19] || (_cache[19] = ($event: any) => ((form.value.userCodes) = $event))
                }, null, 8, ["disabled", "value", "mention"])
              ]),
              _: 1
            }, 8, ["label", "rules"]),
            (!__props.disabled || form.value.fileId)
              ? (_openBlock(), _createBlock(_component_dc_form_item, {
                  key: 1,
                  label: _unref(t)('follow.UploadAttachments'),
                  name: "fileId",
                  span: 24
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(UploadFile), {
                      disabled: __props.disabled,
                      value: form.value.fileId,
                      "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((form.value.fileId) = $event)),
                      valueType: "array",
                      view: __props.view
                    }, null, 8, ["disabled", "value", "view"])
                  ]),
                  _: 1
                }, 8, ["label"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["title"]),
        (_unref(route).path.includes('/ofbu/followUpRecord/add') || _unref(route).path.includes('/ofbu/followUpRecord/visitingPlan'))
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _hoisted_4,
                    _createElementVNode("p", null, _toDisplayString(_unref(t)('common.visitorTabs')), 1),
                    _createElementVNode("div", _hoisted_5, [
                      (hasplay.value)
                        ? (_openBlock(), _createBlock(_component_a_button, {
                            key: 0,
                            danger: "",
                            onClick: _cache[21] || (_cache[21] = ($event: any) => (hasplay.value = false))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('btn.cancel')), 1)
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_a_button, {
                            key: 1,
                            type: "primary",
                            onClick: addVisitPlan,
                            ghost: ""
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)('btn.add')), 1)
                            ]),
                            _: 1
                          }))
                    ])
                  ])
                ]),
                (hasplay.value)
                  ? (_openBlock(), _createBlock(VisitorProgramForm, {
                      key: 0,
                      ref_key: "visitorProgramFormRef",
                      ref: visitorProgramFormRef,
                      type: "add",
                      saleChanceRefId: form.value.followRefId || '--',
                      value: form.value.visitPlanList,
                      "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((form.value.visitPlanList) = $event))
                    }, null, 8, ["saleChanceRefId", "value"]))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("p", null, _toDisplayString(_unref(t)('common.bussiessTabs')), 1),
                  _createElementVNode("div", _hoisted_10, [
                    (hasSaleChance.value)
                      ? (_openBlock(), _createBlock(_component_a_button, {
                          key: 0,
                          danger: "",
                          onClick: _cache[23] || (_cache[23] = ($event: any) => (hasSaleChance.value = false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('btn.cancel')), 1)
                          ]),
                          _: 1
                        }))
                      : (_openBlock(), _createBlock(_component_a_button, {
                          key: 1,
                          type: "primary",
                          onClick: addSaleChance,
                          ghost: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_unref(t)('btn.add')), 1)
                          ]),
                          _: 1
                        }))
                  ])
                ])
              ]),
              (hasSaleChance.value)
                ? (_openBlock(), _createBlock(BusinessForm, {
                    key: 0,
                    ref_key: "saleChanceFormRef",
                    ref: saleChanceFormRef,
                    type: "add",
                    value: form.value.saleChance,
                    "onUpdate:value": _cache[24] || (_cache[24] = ($event: any) => ((form.value.saleChance) = $event)),
                    saleChanceRefId: form.value.followRefId || '--'
                  }, null, 8, ["value", "saleChanceRefId"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["model"]),
    (!__props.disabled)
      ? (_openBlock(), _createBlock(_component_cos_footer_button, {
          key: 0,
          value: form.value,
          "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((form).value = $event)),
          workCode: form.value.dutyBy,
          formRef: baseFormRef.value,
          resetValue: resetValue.value,
          loading: loading.value,
          onSubmit: handleSubmit,
          onReset: handleReset,
          onValidate: validate,
          disabled: __props.disabled,
          permissionPage: __props.permissionPage
        }, null, 8, ["value", "workCode", "formRef", "resetValue", "loading", "disabled", "permissionPage"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})